import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { GetMenuIdsFromToken } from '../services/token.service';
import { ADMIN_MENU_ROUTE_MAPPINGS } from '../config/menu-route.config';
import { ToastService } from '../../shared/services/toast.service';

export const permissionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const toastService = inject(ToastService);

  const routePath = state.url;
  const normalizedPath = routePath.replace(/\/\d+/g, '/:id');

  // Find matching route in ADMIN_MENU_ROUTE_MAPPINGS
  const mapping = ADMIN_MENU_ROUTE_MAPPINGS.find(m => {
    const mappedPath = m.route.replace(/\/\d+/g, '/:id');
    return normalizedPath.startsWith(mappedPath.split('/')[1] ? '/' + mappedPath.split('/')[1] : '/');
  });

  // If no mapping found, allow access (route doesn't require permission check)
  if (!mapping) {
    return true;
  }

  // Get menuIds directly from JWT token
  const userMenuIds = GetMenuIdsFromToken();

  // If no menuIds in token, deny access without redirect (prevents loop)
  if (!userMenuIds || userMenuIds.length === 0) {
    return false;
  }

  if (userMenuIds.includes(mapping.menuId)) {
    return true;
  }

  // User doesn't have permission
  toastService.error('No tienes acceso a esta sección');
  return false;
};
